export default `
<feed-item pinnable="isLoggedInUser" show-pin ng-repeat="article in articleStore.feedItems" item="article" store="articleStore"></feed-item>
<ut-load-more (load-more)="articleStore.loadMore()" [is-loading]="articleStore.isLoading" [is-last-page]="articleStore.isLastPage"></ut-load-more>
`;
